import {useApi} from '@composables/useApi';
import {defineStore} from 'pinia';
import {Referral, User, UserUpdate, SocialProvider} from "@store/api/interfaces";
import {useAuthApi} from "@store/api/authApi";

export const useUserApi = defineStore('userApi', () => {
	const authApi = useAuthApi();

	const get = async (): Promise<User> => {
		return await useApi<User>('/user', {
			method: "GET",
			headers: authApi.methods.getAuthHeaders()
		})
	}

	const update = async (params: UserUpdate): Promise<User> => {
		return await useApi<User>('/user', {
			method: "POST",
			headers: authApi.methods.getAuthHeaders(),
			body: JSON.stringify(params)
		})
	}

	const connect = async(provider: SocialProvider, response: string) => {
		return await useApi(`/connect/${provider}${response}`, {
			method: "GET",
			headers: authApi.methods.getAuthHeaders(),
		});
		// <User>
	}

	const getReferralInfo = async (): Promise<Referral> => {
		return await useApi<Referral>('/referral', {
			method: "GET",
			headers: authApi.methods.getAuthHeaders()
		})
	}

	const setOnboarding = async (): Promise<User> => {
		return await useApi<User>('/onboarding', {
			method: "POST",
			headers: authApi.methods.getAuthHeaders(),
		})
	}

	const setPolicy = async (): Promise<User> => {
		return await useApi<User>('/terms_agree', {
			method: "POST",
			headers: authApi.methods.getAuthHeaders(),
		})
	}

	const disconnect = async (provider: SocialProvider): Promise<User> => {
		const response = await useApi<any>(`/disconnect/${provider}`, {
			method: "POST",
			headers: authApi.methods.getAuthHeaders(),
		});
		// API returns { user: {...} } in data
		return response.user ?? response;
	}

	const verifyEmail = async (): Promise<User> => {
		return await useApi<User>('/email/verify', {
			method: "POST",
			headers: authApi.methods.getAuthHeaders(),
		})
	};

	return {
		get,
		update,
		connect,
		disconnect,
		getReferralInfo,
		setOnboarding,
		setPolicy,
		verifyEmail
	};
})
